import { render, staticRenderFns } from "./DrawingCanvas.vue?vue&type=template&id=62068434&scoped=true"
import script from "./DrawingCanvas.vue?vue&type=script&lang=js"
export * from "./DrawingCanvas.vue?vue&type=script&lang=js"
import style0 from "./DrawingCanvas.vue?vue&type=style&index=0&id=62068434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62068434",
  null
  
)

export default component.exports